import { TGuest, TGuestExtended } from "src/data/guests/types/guestTypes"
import { TIntegration } from "src/data/integrations/types/integrationTypes"
import Favicon from "src/ui/icons/minut-favicon.svg?inline"

/**
 * Extend the data in the response with an integration name and logo,
 * if a match is found
 */
export function extendGuests(
  integrations: TIntegration[],
  guests: TGuest[]
): TGuestExtended[] {
  return guests.map((guest) => extendGuest(guest, integrations))
}

export function extendGuest(
  guest: TGuest,
  integrations: TIntegration[]
): TGuestExtended {
  const integration = integrations.find(
    (i) => i.integration_identifier === guest.source
  )

  return {
    ...guest,
    sourceName: integration?.integration_identifier,
    icon: integration?.icon || Favicon,
  }
}
